function Authenticating() {
    return <p>Authenticating…</p>;
}

export default Authenticating;
